import { Component, OnInit, ViewChild } from '@angular/core';

import { UtilityService, AuthService, AppInformationService, ArkUnitOfWork } from 'app/core/core.module';
import { Family, Person } from 'app/core/model/entity-model';
import { InputDialogComponent } from 'app/shared/input-dialog/input-dialog.component';
import { DevExtremeModule, DxDataGridComponent } from 'devextreme-angular';
import { confirm, alert } from 'devextreme/ui/dialog';
import _ from 'lodash';
import moment from 'moment';
import { BsModalService } from 'ngx-bootstrap/modal';
import { FamiliesDetailComponent } from '../families-detail/families-detail.component';
import { VisitDetailComponent } from '../visit-detail/visit-detail.component';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-sunday-school-overview',
    templateUrl: './sunday-school-overview.component.html',
    styleUrls: ['./sunday-school-overview.component.scss'],
    imports: [DevExtremeModule]
})
export class SundaySchoolOverviewComponent implements OnInit {
    statuses: any;
    peopleStatuses: any;
    familyStatuses: any;
    filter: any;
    people: any[];
    givingYears: any;
    canPrintStatement = false;
    grades = [
        { id: null, name: '(unassigned)' },
        { id: -1, name: 'Pre-School' },
        { id: 0, name: 'Kindegarten' },
        { id: 1, name: '1st' },
        { id: 2, name: '2nd' },
        { id: 3, name: '3rd' },
        { id: 4, name: '4th' },
        { id: 5, name: '5th' },
        { id: 6, name: '6th' },
        { id: 7, name: '7th' },
        { id: 8, name: '8th' },
        { id: 9, name: 'Freshman' },
        { id: 10, name: 'Sophmore' },
        { id: 11, name: 'Junior' },
        { id: 12, name: 'Senior' },
        { id: 13, name: 'Graduated' },
    ];
    schoolYear: string;
    schools: any;
    peopleAdmin = false;

    @ViewChild('dataGrid') dataGrid: DxDataGridComponent;

    constructor(
        private uow: ArkUnitOfWork,
        private auth: AuthService,
        private appInfo: AppInformationService,
        private modalService: BsModalService,
        private route: ActivatedRoute,
        private router: Router
    ) {}

    async ngOnInit() {
        this.peopleAdmin = this.auth.hasRole('PeopleAdmin');
        await this.getData();
    }

    async getData() {
        this.appInfo.pleaseWaitShow();
        this.people = await this.uow.getSundaySchool();
        this.schools = this.uow.lookups.schools;

        this.people.forEach((x) => {
            if (!!_.find(this.grades, { id: x.gradeId })) x.gradeName = _.find(this.grades, { id: x.gradeId }).name;
        });

        const today = new Date();
        const juneCutOff = new Date(new Date().getFullYear(), 5, 2);
        if (today < juneCutOff) {
            this.schoolYear = `${today.getFullYear() - 1}-${today.getFullYear()}`;
        } else {
            this.schoolYear = `${today.getFullYear()}-${today.getFullYear() + 1}`;
        }

        this.appInfo.pleaseWaitHide();
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarButtons',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'refresh',
                    elementAttr: { title: 'Reset Grid Layout' },
                    onClick: () => {
                        e.component.state({});
                    },
                },
                location: 'after',
            },
            {
                template: 'toolbarText',
                location: 'after',
            }
        );
    }

    async onValueChanged(e) {
        if (!this.filter.statusId) return;
        await this.getData();
    }

    rowPrepare(e) {
        if (e.rowType === 'data') {
            // if (!e.data.days) e.rowElement.className = e.rowElement.className + ' visits-yellow-grid';
            if (!!e.data.days || e.data.days === 0) {
                if (e.data.days < 180) e.rowElement.className = e.rowElement.className + ' visits-green-grid';
                if (e.data.days >= 180 && e.data.days < 365) e.rowElement.className = e.rowElement.className + ' visits-yellow-grid';
                if (e.data.days >= 365) e.rowElement.className = e.rowElement.className + ' visits-red-grid';
            }
        }
    }

    openPerson(personId?) {
        if (!this.peopleAdmin) return;
        if (!!personId) this.router.navigate(['../' + personId], { relativeTo: this.route });
        else this.router.navigate(['../' + 'new'], { relativeTo: this.route });
    }

    async open(data: any) {
        const modalRef = this.modalService.show(FamiliesDetailComponent, {
            class: 'modal-lgw',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                // family: data.family,
                key: data.familyId,
                showAsDialog: true,
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            if (result.success) {
                // await this.getData();
            }
            modalRef.hide();
        });
    }

    async updateGrade() {
        const selectedRows = this.dataGrid.instance.getSelectedRowsData();
        if (!selectedRows) return;

        const today = new Date();
        const currentMonth = moment(today).month();
        let schoolYear = '';
        if (currentMonth >= 8) {
            // js calculates months as 0-11
            schoolYear = `${moment(today).year()}-${moment(today).year() + 1}`;
        } else schoolYear = `${moment(today).year() - 1}-${moment(today).year()}`;

        const modalRef = this.modalService.show(InputDialogComponent, {
            class: 'modal-md',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                dialogHeader: 'Update Status',
                dialogPrompt: `Select Grade for ${schoolYear} School Year`,
                dialogValueArray: this.grades,
                mode: 'selectWithId',
            },
        });

        const array = selectedRows;
        const promise = new Promise<number>(async (resolve, reject) => {
            modalRef.content.result.subscribe(async (result) => {
                if (result.success) {
                    let year = 0;
                    if (currentMonth >= 8) year = moment(today).year();
                    else year = moment(today).year() + 1;

                    for (let index = 0; index < array.length; index++) {
                        const person = (await this.uow.people.byId(array[index].id)) as Person;
                        if (!result.value && result.value !== 0) person.graduationDate = null;
                        else person.graduationDate = new Date(year + (13 - result.value), 5, 1); // js calculates months as 0-11
                    }

                    await this.uow.commit();
                    await this.getData();
                    this.appInfo.pleaseWaitHide();

                    resolve(result.value);
                }
                modalRef.hide();
                resolve(null);
            });
        });
    }

    async updateSchool() {
        const selectedRows = this.dataGrid.instance.getSelectedRowsData();
        if (!selectedRows) return;

        const people = await this.uow.people.byIds(
            selectedRows.map((x) => {
                return x.id;
            })
        );

        const modalRef = this.modalService.show(InputDialogComponent, {
            class: 'modal-sm',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                dialogHeader: 'Update School',
                dialogPrompt: `Select School`,
                dialogValueArray: this.schools,
                mode: 'selectWithId',
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            if (result.success) {
                this.appInfo.pleaseWaitShow();
                console.log(result.value);
                people.forEach((person) => {
                    person.schoolId = result.value;
                });
                await this.uow.commit();
                await this.getData();
                this.appInfo.pleaseWaitHide();
            }
            modalRef.hide();
        });
    }
}
